import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import Avatar from 'vue-avatar'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('Avatar', Avatar)
